import { AGE_VERIFICATION_PROVIDER_URL } from '../constants/apiUrls/apiUrls';


export async function getAgeVerificationProviderUrl(params) {
  const createHeaders = () => {
    const obj = {};
    if (sessionStorage.getItem('username')) {
      obj.username = sessionStorage.getItem('username');
    }
    if (sessionStorage.getItem('token')) {
      obj.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
    }

    return obj;
  };

  const queryString = new URLSearchParams(params).toString();
  const url = `${AGE_VERIFICATION_PROVIDER_URL}${queryString ? `?${queryString}` : ''}`;

  const response = await fetch(url, {
    headers: createHeaders(),
    redirect: 'manual',
  });

  if (response.status >= 300 && response.status < 400) {
    const location = response.headers.get('Location');
    if (location) {
      return { data: { data: { ageVerificationUrl: location } } };
    }
  }

  if (response.ok) {
    const data = await response.json();

    return { data };
  }

  throw new Error(`Failed to get verification URL: ${response.status}`);
}
